import { render } from "./FactBox.vue?vue&type=template&id=f78e8d30"
import script from "./FactBox.vue?vue&type=script&lang=js"
export * from "./FactBox.vue?vue&type=script&lang=js"

import "./FactBox.vue?vue&type=style&index=0&id=f78e8d30&lang=scss"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__